import { Component, OnInit, ElementRef, Renderer2, ViewChild, TemplateRef, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FlowManagementService } from '../services/flow-management.service';
import { NotificationService } from '@progress/kendo-angular-notification';

@Component({
    selector: 'app-clipboard',
    templateUrl: './clipboard.component.html',
    styleUrls: ['./clipboard.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class ClipboardComponent implements OnInit {


  public searchTerm = '';
  public clips = [];
  public community = [
    {
      "id": "f5381033-0498-4ee4-bb73-0029-e7efed3e", 
      "brandColor": "#758393", 
      "connectionReferences": {}, 
      "connectorDisplayName": "Control", 
      "icon": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDMyIDMyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPg0KIDxwYXRoIGQ9Im0wIDBoMzJ2MzJoLTMyeiIgZmlsbD0iIzc1ODM5MyIvPg0KIDxnIGZpbGw9IiNmZmYiPg0KICA8cGF0aCBkPSJNMTEuNDI5IDIwLjMxaDEyLjU3MXYxLjE0M2gtMTMuNzE0di0zLjU0M2wtMS40ODYgMS40ODYtLjgtLjggMi44NTctMi44NTcgMi44NTcgMi44NTctLjguOC0xLjQ4Ni0xLjQ4NnoiLz4NCiAgPHBhdGggZD0iTTIyLjg1NyAyMS4zNjh2LTkuODM2aC04di0uOTg0aDkuMTQzdjEwLjgyIi8+DQogIDxwYXRoIGQ9Im05LjE0MyAxMC41NDhoMy40Mjl2My40MjloLTMuNDI5eiIvPg0KIDwvZz4NCjwvc3ZnPg0K", 
      "isTrigger": false, 
      "operationName": "loop_state_machine", 
      "operationDefinition": { 
        "type": "Until", 
        "expression": "@equals(variables('state'), 'Final')", 
        "limit": { 
          "count": 5000, 
          "timeout": "PT30D" 
        }, 
        "actions": { 
          "Switch": { 
            "type": "Switch", "expression": "@variables('state')", 
            "cases": { 
              "Case": { "case": "First", "actions": { "state_to_Second": { "type": "SetVariable", "inputs": { "name": "state", "value": "Second" }, "runAfter": {} } } }, 
              "Case_2": { "case": "Second", "actions": { "state_to_Third": { "type": "SetVariable", "inputs": { "name": "state", "value": "Third" }, "runAfter": {} } } }, 
              "Case_3": { "case": "Third", "actions": { "state_to_Final": { "type": "SetVariable", "inputs": { "name": "state", "value": "Final" }, "runAfter": {} } } } }, 
              "default": { "actions": {} }, 
              "runAfter": { "READ_ME": ["Succeeded"] } 
            }, 
            "READ_ME": { "type": "Compose", "inputs": "1. create a variable \"state\" before the state machine loop\n2. review Doctor Flow's state machine: https://sergeluca.wordpress.com/2018/01/21/pattern-for-implementing-state-machines-with-microsoft-flow/ \n", "runAfter": {} } }, "runAfter": { "Initialize_variable": ["Succeeded"] }, 
        "description": "README: create variable \"state\" before state machine loop" 
      },
      "url": "https://sergeluca.wordpress.com/2018/01/21/pattern-for-implementing-state-machines-with-microsoft-flow/",
      "credit": "Serge Luca, #DoctorFlow"
    }
  ];
  public subscriptions = [
    {
      "id":"5dee3440-986d-4e77-9131-2abe-6bf7e57c",
      "brandColor":"#8C3900",
      "connectionReferences":{"shared_sharepointonline":{"connection":{"id":"/providers/Microsoft.PowerApps/apis/shared_sharepointonline/connections/shared-sharepointonl-f1a6c0d5-6c9b-4f24-8ae6-2bde68cecb3f"}}},
      "connectorDisplayName":"Control",
      "icon":"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDMyIDMyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPg0KIDxwYXRoIGQ9Im0wIDBoMzJ2MzJoLTMyeiIgZmlsbD0iIzhDMzkwMCIvPg0KIDxwYXRoIGQ9Im04IDEwaDE2djEyaC0xNnptMTUgMTF2LTEwaC0xNHYxMHptLTItOHY2aC0xMHYtNnptLTEgNXYtNGgtOHY0eiIgZmlsbD0iI2ZmZiIvPg0KPC9zdmc+DQo=",
      "isTrigger":false,
      "operationName":"Scope Create Document Set",
      "operationDefinition":{
        "type":"Scope",
        "actions":{"param_SharePoint_URL":{"type":"Compose","inputs":"https://johnliu365.sharepoint.com/","runAfter":{}},"param_document_library":{"type":"Compose","inputs":"DocSetLib","runAfter":{"param_SharePoint_URL":["Succeeded"]},"description":"title of the library to create the document set in"},"param_docset_content_type_name":{"type":"Compose","inputs":"Document Set","runAfter":{"param_document_library":["Succeeded"]},"description":"name of the Document Set content type in your library, this is used to find the Document Set content type ID"},"param_docset_name":{"type":"Compose","inputs":"ViaFlowDS1","runAfter":{"param_docset_content_type_name":["Succeeded"]},"description":"name of the new Document Set to be created"},"GET_DocumentSet_ID":{"type":"ApiConnection","inputs":{"host":{"connection":{"name":"@json(decodeBase64(triggerOutputs().headers['X-MS-APIM-Tokens']))['$connections']['shared_sharepointonline']['connectionId']"}},"method":"post","body":{"method":"GET","uri":"_api/web/lists/getbytitle('@{outputs('param_document_library')}')/contenttypes?$filter=Name eq '@{outputs('param_docset_content_type_name')}'&$select=ID","headers":{"accept":"application/json; odata=nometadata"}},"path":"/datasets/@{encodeURIComponent(encodeURIComponent(outputs('param_SharePoint_URL')))}/httprequest","authentication":{"type":"Raw","value":"@json(decodeBase64(triggerOutputs().headers['X-MS-APIM-Tokens']))['$ConnectionKey']"}},"runAfter":{"param_docset_name":["Succeeded"]},"metadata":{"flowSystemMetadata":{"swaggerOperationId":"HttpRequest"}}},"Create_Document_Set":{"type":"ApiConnection","inputs":{"host":{"connection":{"name":"@json(decodeBase64(triggerOutputs().headers['X-MS-APIM-Tokens']))['$connections']['shared_sharepointonline']['connectionId']"}},"method":"post","body":{"method":"POST","uri":"_vti_bin/listdata.svc/@{replace(outputs('param_document_library'),' ','')}","headers":{"slug":"/@{outputs('param_document_library')}/@{outputs('param_docset_name')}|@{first(body('GET_DocumentSet_ID')?['value'])?['Id']?['StringValue']}"}},"path":"/datasets/@{encodeURIComponent(encodeURIComponent(outputs('param_SharePoint_URL')))}/httprequest","authentication":{"type":"Raw","value":"@json(decodeBase64(triggerOutputs().headers['X-MS-APIM-Tokens']))['$ConnectionKey']"}},"runAfter":{"GET_DocumentSet_ID":["Succeeded"]},"metadata":{"flowSystemMetadata":{"swaggerOperationId":"HttpRequest"}}}},"runAfter":{},
        "description":""      
      },
      "url": "https://twitter.com/johnnliu/status/992767564253089792",
      "credit": "John Liu, #FlowNinja 16"
    }
  ]
  public ready = false;
  public message = '';

  @ViewChild('template', { read: TemplateRef, static: true })
  public notificationTemplate: TemplateRef<any>;

  constructor(
    private element: ElementRef,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer,
    private flowManagementService: FlowManagementService,
    private notificationService: NotificationService
  ) { 

  }

  ngOnInit() {
    // this.renderer.listen(this.element.nativeElement, 'copy', (event) => {
    //   // do your stuff
    // });
    this.ready = false;
    this.flowManagementService.getClips().then(clips=>{
      this.clips = clips;
      this.ready = true;
    });
 
    let onPaste = (event) => {

      Promise.resolve().then(()=>{

        if (window['clipboardData']) {
          let clip = window['clipboardData'].getData('Text');
          return clip;
        }

        return navigator['clipboard'].readText()

      }).then(clipText=>{

        this.message = `${clipText} doesn't look like a supported Flow snippet.`;
        try {
          let clip = JSON.parse(clipText);

          if (typeof(clip) != "object" || !clip.id || !clip.connectorDisplayName || !clip.operationName) {
            this.notificationService.show({
              content: this.notificationTemplate,
              animation: { type: 'fade', duration: 15 },
              type: { style: 'warning', icon: true },
              //closable: true,
              position: { horizontal: 'center', vertical: 'top' }
            });
            return;
          }

          let index = this.clips.findIndex((c=>c.id == clip.id))

          if (index == -1) {
            this.clips.push(clip);  
            this.message = `Clip ${clip.operationName} added.`
          }
          else {
            this.clips[index] = clip;
            this.message = `Clip ${clip.operationName} replaced ${clip.id}.`
          }
          this.saveClips();

          this.notificationService.show({
            content: this.notificationTemplate,
            animation: { type: 'fade', duration: 15 },
            type: { style: 'info', icon: true },
            //closable: true,
            position: { horizontal: 'center', vertical: 'top' }
          });

        }
        catch(error) {
          this.notificationService.show({
            content: this.notificationTemplate,
            animation: { type: 'fade', duration: 15 },
            type: { style: 'warning', icon: true },
            //closable: true,
            position: { horizontal: 'center', vertical: 'top' }
          });
        }
      });

    };

    //this.renderer.listen(this.element.nativeElement, 'paste', onPaste);
    this.renderer.listen('document', 'paste', onPaste);
  
  }

  public saveClips() {
    this.ready = false;
    this.flowManagementService.updateClips(this.clips).then(()=>{
      this.ready = true;
    });
  }

  public removeClip(clip) {
    if (this.ready == false) {
      return;
    }
    this.clips = this.clips.filter( c=>c.id != clip.id);
    this.saveClips();
  }

  public safeUrl(url) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  public stringify(clip) {
    return JSON.stringify(clip);
  }

  public copied(clip) {
    this.message = `Clip ${clip.operationName} copied.`
    this.notificationService.show({
      content: this.notificationTemplate,
      animation: { type: 'fade', duration: 15 },
      type: { style: 'info', icon: true },
      //closable: true,
      position: { horizontal: 'center', vertical: 'top' }
    });
  }

  public exportClips() {
    const json = JSON.stringify(this.clips, null, 2);
    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'flow-studio-clipboard.json';
    a.click();
    URL.revokeObjectURL(url);
  }

  public importClips(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;
    file.text().then(text => {
      try {
        const imported = JSON.parse(text);
        if (!Array.isArray(imported)) {
          this.message = 'Invalid file: expected a JSON array of clips.';
          this.notificationService.show({ content: this.notificationTemplate, animation: { type: 'fade', duration: 15 }, type: { style: 'warning', icon: true }, position: { horizontal: 'center', vertical: 'top' } });
          return;
        }
        let added = 0;
        let updated = 0;
        for (const clip of imported) {
          if (!clip.id || !clip.connectorDisplayName || !clip.operationName) continue;
          const index = this.clips.findIndex(c => c.id === clip.id);
          if (index === -1) {
            this.clips.push(clip);
            added++;
          } else {
            this.clips[index] = clip;
            updated++;
          }
        }
        this.saveClips();
        this.message = `Imported ${added} new, ${updated} updated clip(s).`;
        this.notificationService.show({ content: this.notificationTemplate, animation: { type: 'fade', duration: 15 }, type: { style: 'info', icon: true }, position: { horizontal: 'center', vertical: 'top' } });
      } catch {
        this.message = 'Failed to parse JSON file.';
        this.notificationService.show({ content: this.notificationTemplate, animation: { type: 'fade', duration: 15 }, type: { style: 'warning', icon: true }, position: { horizontal: 'center', vertical: 'top' } });
      }
      input.value = '';
    });
  }

  get filteredClips() {
    if (!this.searchTerm) return this.clips;
    const term = this.searchTerm.toLowerCase();
    return this.clips.filter(c => c.operationName?.toLowerCase().includes(term) || c.connectorDisplayName?.toLowerCase().includes(term));
  }

  get filteredCommunity() {
    if (!this.searchTerm) return this.community;
    const term = this.searchTerm.toLowerCase();
    return this.community.filter(c => c.operationName?.toLowerCase().includes(term) || c.connectorDisplayName?.toLowerCase().includes(term) || c.credit?.toLowerCase().includes(term));
  }

  get filteredSubscriptions() {
    if (!this.searchTerm) return this.subscriptions;
    const term = this.searchTerm.toLowerCase();
    return this.subscriptions.filter(c => c.operationName?.toLowerCase().includes(term) || c.connectorDisplayName?.toLowerCase().includes(term) || c.credit?.toLowerCase().includes(term));
  }

  get whohasfocus() {
    return document.activeElement;
  }

}
